import { render, staticRenderFns } from "./VPPSection.vue?vue&type=template&id=46b55ad5&scoped=true&"
import script from "./VPPSection.vue?vue&type=script&lang=js&"
export * from "./VPPSection.vue?vue&type=script&lang=js&"
import style0 from "./VPPSection.vue?vue&type=style&index=0&id=46b55ad5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b55ad5",
  null
  
)

export default component.exports